// src/presentation/reusables/CardProgress/index.tsx
import React from 'react';
import parser from 'html-react-parser';
import { Container } from './style';
import ReusableInfo from '../Info';
import { renderCommentary, SAE_TEXT } from './constants';

const CardProgress = ({
  image,
  title,
  subtitle,
  children,
  comentary,
  SAE
}: any) => (
  <Container className="boxShadow">
    <div className="image">
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet={`${image[1]} 768w`}
          sizes="768px"
        />
        <source srcSet={`${image[0]}`} />
        <img src={Array.isArray(image) ? image[0] : image} alt="" />
      </picture>
    </div>

    <div>
      <p className="title">{parser(title)}</p>
      <div className="subtitle">{parser(subtitle)}</div>

      {comentary && (
        <p data-testid="commentary">
          <b>Comentario:</b>{' '}
          <span data-testid="comentary-text">
            {renderCommentary(comentary)}
          </span>
        </p>
      )}

      {SAE && (
        <div
          data-testid="cmp-reusable-info-wrapper"
          style={{ margin: '12px 0px 0px 0px' }}
        >
          <ReusableInfo
            style={{ margin: '12px 0px 0px 0px' }}
            text={SAE_TEXT}
          />
        </div>
      )}
      {children}
    </div>
  </Container>
);

CardProgress.defaultProps = {
  title: '',
  subtitle: '',
  comentary: '',
  SAE: ''
};

export default CardProgress;
